<template>
	<dynvibebasechart
		:id="axiosComputed"
		ref="basechart"
		@created="chartCreated"
		:functionClick="clickGraph"
		:type="type"
	></dynvibebasechart>
</template>
<script>
import graphMixin from "@/mixins/graphMixin.js";
export default {
	name: "dynvibecolumnstacked",
	mixins: [graphMixin],
	props: {
		noStacked: {
			type: Boolean,
			default: false,
		},
		displayGrowth: {
			type: Boolean,
			default: false,
		},
		filters: Object,
	},

	data() {
		return {
			stackedSeries: {},
			series: {},
			categories: [],
		};
	},
	methods: {
		chartCreated() {
			this.baseChart = this.$refs.basechart;
			this.setChartOptions();
		},
		setChartOptions() {
			let baseChart = this.$refs.basechart;
			let chartOptions = baseChart.getChartOptions();

			chartOptions.colors = this.graphColor;
			chartOptions.chart.type = "column";
			chartOptions.xAxis.min = 0;
			chartOptions.xAxis.max = 0;
			chartOptions.xAxis.scrollbar = {
				enabled: false,
			};
			chartOptions.xAxis.labels = {
				rotation: 0,
				style: {
					"text-transform": "uppercase",
				},
			};

			delete chartOptions.yAxis.labels;
			chartOptions.yAxis.min = 0;
			chartOptions.yAxis.stackLabels = {
				enabled: false,
				style: {
					fontWeight: "bold",
					color: "gray",
				},
			};

			delete chartOptions.legend;
			delete chartOptions.plotOptions.bar;
			chartOptions.plotOptions = {
				column: {
					stacking: "normal",
					dataLabels: {
						enabled: false,
						color: "white",
					},
				},
				series: {
					events: {
						click: this.clicked,
					},
				},
			};

			chartOptions = this.optionDisplayGrowth(chartOptions);
			baseChart.updateChartOptions(chartOptions);
		},
		optionDisplayGrowth(chartOptions) {
			if (this.displayGrowth) {
				chartOptions.tooltip = {
					backgroundColor: null,
					borderWidth: 0,
					shadow: false,
					useHTML: true,
					style: {
						padding: 0,
						zIndex: 100,
					},
				};

				chartOptions.plotOptions.column = {
					dataLabels: {
						enabled: true,
					},
				};

				if (chartOptions.series.length > 0) {
					chartOptions.series[0].dataLabels = {
						enabled: false,
					};

					chartOptions.series[1].dataLabels = {
						enabled: true,
					};
				}
			} else {
				chartOptions.tooltip = {
					backgroundColor: null,
					borderWidth: 0,
					shadow: false,
					useHTML: true,
					style: {
						padding: 0,
					},
				};
				chartOptions.plotOptions.column = {
					dataLabels: {
						enabled: false,
					},
				};

				if (chartOptions.series.length > 0) {
					for (let i = 0; i < chartOptions.series.length; i++) {
						chartOptions.series[i].dataLabels = {
							enabled: false,
						};
					}
				}
			}

			return chartOptions;
		},
		loadChartData(results, loading = true) {
			let baseChart = this.$refs.basechart;
			let chartOptions = baseChart.getChartOptions();
			baseChart.setNoData(false);
			baseChart.setLoading(true);

			if (loading == true) {
				this.categories = results.categories;
				this.series = JSON.parse(JSON.stringify(results.values)); // Clone

				if (results.stackedValues) {
					this.stackedSeries = JSON.parse(JSON.stringify(results.stackedValues)); // Clone
				}
			}

			chartOptions.plotOptions.column.stacking = this.noStacked == false ? "normal" : undefined;

			if (results.values.length == 0) {
				chartOptions.xAxis.categories = [];
				chartOptions.series = [];
				baseChart.setNoData(true);
			} else {
				chartOptions.xAxis.categories = results.categories;

				// To add default colors
				let seriesOptions = [];
				let colorByCountry = [];

				for (let i = 0; i < results.values.length; i++) {
					seriesOptions[i] = results.values[i];

					// To have the same colors between the two country columns side by side
					if (colorByCountry.find((v) => v.name === results.values[i]["name"]) === undefined) {
						colorByCountry.push({
							name: results.values[i]["name"],
							color: this.graphColor[i],
						});
						seriesOptions[i].color = this.graphColor[i];
					} else {
						const r = colorByCountry.find((v) => v.name === results.values[i]["name"]);
						seriesOptions[i].color = r["color"];
					}
				}

				chartOptions.series = seriesOptions;

				// Gray columns when mastertag or trend is selected
				if (this.axios == "volumeComparison") {
					if (this.filters.mastertag != "" || this.filters.trend != "") {
						chartOptions = this.useGrayColumns(chartOptions);
					}
				}

				if (results.values.length && results.values[0].data.length === 1) {
					chartOptions.xAxis.max = 0;
					chartOptions.xAxis.scrollbar.enabled = false;
				} else {
					chartOptions.xAxis.max = 10;
					if (results.values.length && results.values[0].data.length <= 10) {
						chartOptions.xAxis.max = results.values[0].data.length - 1;
					}
					chartOptions.xAxis.scrollbar.enabled = true;
				}

				if (this.displayGrowth) {
					chartOptions = this.useDisplayGrowth(chartOptions);
				}
			}
			baseChart.setLoading(false);
			baseChart.updateChartOptions(chartOptions);
			baseChart.setVisible();
		},
		useDisplayGrowth(chartOptions) {
			function formatter() {
				let newValue = this.y;
				// Gray columns or not
				let oldValue;
				if (chartOptions.series[0].data.length > this.point.index) {
					oldValue =
						typeof chartOptions.series[0].data[this.point.index].y !== "undefined"
							? chartOptions.series[0].data[this.point.index].y
							: chartOptions.series[0].data[this.point.index];
				}

				let evolution = 0;
				if (oldValue === 0 || newValue === 0 || oldValue === newValue) {
					return "";
				} else {
					evolution = ((newValue - oldValue) / oldValue) * 100;
				}
				evolution = Math.round(evolution);
				//return Highcharts.numberFormat(evolution, 2) + "%";
				let html = '<span class="';
				html += evolution > 0 ? "highchart-growth-up" : "highchart-growth-down";
				html += '">';
				html += evolution > 0 ? "+" : "";
				html += evolution + "%";
				html += "</span";
				return html;
			}

			if (this.noStacked && chartOptions.series.length > 0) {
				chartOptions.series[0].dataLabels = {
					enabled: false,
				};
				chartOptions.series[1].dataLabels = {
					enabled: true,
					align: "center",
					useHTML: true,

					formatter: function () {
						return formatter.call(this);
					},
				};
			} else {
				if (chartOptions.series.length > 0) {
					for (let i = 0; i < chartOptions.series.length; i++) {
						chartOptions.series[i].dataLabels = {
							enabled: false,
						};
					}
				}
			}

			return chartOptions;
		},
		useGrayColumns(chartOptions) {
			let categoryKey =
				this.filters.mastertag != ""
					? Object.keys(this.categories).find((key) => this.categories[key] === this.filters.mastertag)
					: Object.keys(this.categories).find((key) => this.categories[key] === this.filters.trend);

			for (let i = 0; i < chartOptions.series.length; i++) {
				let oldData = chartOptions.series[i].data;
				let newData = [];
				for (let j = 0; j < oldData.length; j++) {
					let color;
					if (i == 0) {
						if (j == categoryKey) {
							color = this.graphColor[0];
						} else {
							color = "#C2C2C2";
						}
					}
					if (i >= 1) {
						if (j == categoryKey) {
							color = this.graphColor[1];
						} else {
							color = "#9D9D9D";
						}
					}

					newData.push({
						y: oldData[j],
						color: color,
					});
				}
				chartOptions.series[i].data = newData;
			}
			return chartOptions;
		},
		clicked(item) {
			let country = "";
			if (this.noStacked == false) {
				country = item.point.series.name;
			}

			let date = { gte: this.filters.date.gte, lte: this.filters.date.lte };
			if (item.point.series.columnIndex == 0) {
				let gte = this.$moment(this.filters.date.gte);
				let lte = this.$moment(this.filters.date.lte);
				let daysDiff = lte.diff(gte, "days");
				date.lte = gte.subtract(1, "days").format("YYYY-MM-DD");
				date.gte = gte.subtract(daysDiff, "days").format("YYYY-MM-DD");
			}

			this.$emit("clicked", {
				keyword: item.point.category, // Column
				country: country,
				date: date,
			});
		},
	},
	watch: {
		noStacked: function () {
			let results;
			if (this.noStacked == false) {
				results = {
					categories: this.categories,
					values: JSON.parse(JSON.stringify(this.stackedSeries)), // Clone
				};
			} else {
				results = {
					categories: this.categories,
					values: JSON.parse(JSON.stringify(this.series)), // Clone
				};
			}
			this.loadChartData(results, false);
		},
		displayGrowth: function () {
			let chartOptions = this.baseChart.getChartOptions();
			chartOptions = this.optionDisplayGrowth(chartOptions);
			this.baseChart.updateChartOptions(chartOptions);
		},
	},
};
</script>
<style>
.highcharts-tooltip > span {
	background: rgba(255, 255, 255, 0.85);
	border: 1px solid silver;
	border-radius: 3px;
	box-shadow: 1px 1px 2px #888;
	padding: 8px;
	z-index: 1000;
}

.highchart-growth-up {
	background-color: #23056b;
	color: #fff;
	font-size: 9px;
	padding: 4px;
	position: inherit;
	left: -25px;
	top: -25px;
	z-index: 1;
}

.highchart-growth-down {
	background-color: #fe5c5d;
	color: #fff;
	font-size: 9px;
	padding: 4px;
	position: inherit;
	left: -25px;
	top: -25px;
	z-index: 1;
}
</style>
